// extracted by mini-css-extract-plugin
export var originalCard = "goodsCard-module--originalCard--louty";
export var thumb = "goodsCard-module--thumb--2WmZ0";
export var content = "goodsCard-module--content--2wYR9";
export var btm = "goodsCard-module--btm--25v0H";